import { render, staticRenderFns } from "./licensePlate.vue?vue&type=template&id=3637377e&scoped=true"
import script from "./licensePlate.vue?vue&type=script&lang=js"
export * from "./licensePlate.vue?vue&type=script&lang=js"
import style0 from "./licensePlate.vue?vue&type=style&index=0&id=3637377e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3637377e",
  null
  
)

export default component.exports